import * as PIXI from 'pixi.js';

export default class Tappable extends PIXI.Container {
    constructor(opts = { shouldStopEventPropagation: false }) {
        super();

        this.tapTimeout = 700;
        this.dragThreshold = 70;

        this.eventMode = 'static';

        let timeout;
        let heldInitialPosition;
        let pointerDownOnThisLeader = false;

        this.on('pointerdown', (event) => {
            if (opts.shouldStopEventPropagation) {
                event.stopPropagation();
            }

            pointerDownOnThisLeader = true;
            if (event && event.global && event.global.clone) {
                heldInitialPosition = event.global.clone();
            } else {
                heldInitialPosition = null;
            }
            this.onHoldStart?.();

            timeout = setTimeout(() => {
                pointerDownOnThisLeader = false;
                heldInitialPosition = null;
                this.onHeld?.();
                this.onHoldEnd?.();
            }, this.tapTimeout);
        });

        this.on('pointerup', (event) => {
            if (opts.shouldStopEventPropagation) {
                event.stopPropagation();
            }

            clearTimeout(timeout);

            if (pointerDownOnThisLeader) {
                this.onTap?.();
                this.onHoldEnd?.();
            }
            pointerDownOnThisLeader = false;
            heldInitialPosition = null;
        });

        this.on('globalpointermove', (event) => {
            if (opts.shouldStopEventPropagation) {
                event.stopPropagation();
            }
            
            if (!pointerDownOnThisLeader || !heldInitialPosition) return;
            const movePosition = event.global;
            const dx = movePosition.x - heldInitialPosition.x;
            const dy = movePosition.y - heldInitialPosition.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            if (distance > this.dragThreshold) {
                pointerDownOnThisLeader = false;
                clearTimeout(timeout);
                if (Math.abs(dx) > Math.abs(dy)) {
                    if (dx < 0) this.onSwipeLeft?.();
                    else this.onSwipeRight?.();
                }
                heldInitialPosition = null;
                this.onDragStarted?.();
                this.onHoldEnd?.();
            }
        });
    }
}